<template>
  <div class="customer-segment">
    <div class="segment-header">
      <div class="segment-info">
        <div class="segment-info-item">
          <div class="segment-info-item-header">Segment name:</div>
          <div class="segment-info-item-value" style="color: #007fff">Birthday Customer</div>
        </div>
        <div class="segment-info-item">
          <div class="segment-info-item-header">Folder:</div>
          <div class="segment-info-item-value">Default</div>
        </div>
        <div class="segment-info-item">
          <div class="segment-info-item-header">Segment size:</div>
          <div class="segment-info-item-value">3,940</div>
        </div>
        <div class="segment-info-item">
          <div class="segment-info-item-header">Segment Type:</div>
          <div class="segment-info-item-value"><segment-type :type="resolveSegmentType(2)" /></div>
        </div>
        <div class="segment-info-item">
          <div class="segment-info-item-header">Last Update:</div>
          <div class="segment-info-item-value">เมื่อ 1 นาทีที่แล้ว</div>
        </div>
        <div class="segment-info-item">
          <div class="segment-info-item-header">Campaign:</div>
          <div class="segment-info-item-value">
            <div
              class="campaign-status-symbol"
              :class="['campaign-status-progress', true ? 'available' : '', false ? 'redeemed' : '', false ? 'delivered' : '']"
            />
            กำลังดำเนินการแคมเปญ
          </div>
        </div>
      </div>
      <div class="segment-actions">
        <div class="cal-button-container">
          <button class="btn btn-outline-primary d-flex align-items-center cal-button" @click="onClickCalButton">
            <div class="cal-icon">
              <calculate-icon class="icon-cal" />
            </div>
            <div class="button-text">{{ 'คำนวณอัตราการเลิกเป็นลูกค้า' }}</div>
          </button>
        </div>
      </div>
    </div>

    <div class="segment-nav">
      <div class="segment-nav-tab-container">
        <!-- <button @click="onClickTabNav('DASHBOARD')" class="nav-button" :class="tabNavActive == 'DASHBOARD' ? 'active' : ''">
          <AnalyticIcon /> Dashboard
        </button> -->
        <button @click="onClickTabNav('CUSTOMERLIST')" class="nav-button end-nav-button" :class="tabNavActive == 'CUSTOMERLIST' ? 'active' : ''">
          <AnalyticIcon /> Churn Customer
        </button>
      </div>
      <div class="segment-nav-button-container">
        <dropdown-button
          class="button-item dropdown-save"
          align="right"
          :dropdownList="itemDropdownSave"
          @on-click-item="onClickSaveOpensaveSegmentModal"
        >
          <template v-slot:prepend>
            <save-icon />
          </template>
        </dropdown-button>
        <dropdown-button class="button-item dropdown-share" :dropdownList="itemDropdownShare" @on-click-item="onClickShare">
          <template v-slot:prepend>
            <share-icon />
          </template>
        </dropdown-button>
        <search-button class="space-search ms-2" v-model="textSearch" :disabled="onBusy" />
        <div class="export-button-container">
          <button
            class="btn d-flex align-items-center"
            v-bt-tooltips="{ bgColor: '#30a704', color: '#ffffff' }"
            title="Export CSV."
            :disabled="loadingExportCsv"
            @click="onExportCSV"
          >
            <template v-if="!loadingExportCsv">
              <download-icon />
            </template>
            <template v-else>
              <div class="spinner-border-container">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </template>
          </button>
        </div>
        <div class="date-range-picker">
          <choco-date-range-picker
            class="choco-date-range-picker"
            v-model:start="startDate"
            v-model:end="endDate"
            :relative-options="['today', 'P7D', 'P15D', 'P30D', 'P90D']"
            v-model:relative-model="relativeModel"
            :format="'dd MMM yyyy'"
            relative-title="Date Range"
            relative-title-class="font-f1"
            @click="onClickDateSelect"
            @hide="() => {}"
            :is-show-apply-button="true"
          >
            <template v-slot:input="props">
              <date-range-display-input class="input" v-bind="props" prepend-icon />
            </template>
          </choco-date-range-picker>
        </div>
        <div class="bi-reset-date-picker" @click="onResetDate" v-bt-tooltips :title="'reset'">
          <ResetIcon />
        </div>
      </div>
    </div>

    <div v-if="tabNavActive == 'DASHBOARD'" class="body-content-container"><InsightTabDashboard /></div>
    <div v-else-if="tabNavActive == 'CUSTOMERLIST'" class="body-content-container"><InsightTabChurnCustomer /></div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref, Ref, markRaw } from 'vue';
import router from '@/router';
import CalculateIcon from '@/assets/icons/modules/analytics/churn-rate/CalculateIcon.vue';
import AnalyticIcon from '@/assets/icons/base/navbarIcon/AnalyticIcon.vue';
import BaseButton from '@/views/components/button/BaseButton.vue';
import SearchButton from '@/views/components/button/IconButton/SearchButton.vue';
import { ChocoDateRangePicker } from '@choco-platform/components';
import DropdownButton from '@/views/components/button/DropdownButton.vue';
import BoxIcon from '@assets/icons/base/button/BoxIcon.vue';
import SaveIcon from '@assets/icons/base/button/SaveIcon.vue';
import ShareIcon from '@assets/icons/base/button/ShareIcon.vue';
import SmsIcon from '@assets/icons/base/button/SmsIcon.vue';
import EmailIcon from '@assets/icons/base/button/EmailIcon.vue';
import LineIcon from '@assets/icons/base/button/LineIcon.vue';
import InsightTabChurnCustomer from '@/views/modules/analytics/components/anal-churnrate/InsightTabChurnCustomer.vue';
import InsightTabDashboard from '@/views/modules/analytics/components/anal-churnrate/InsightTabDashboard.vue';
import ResetIcon from '@/assets/icons/modules/analytics/bi/ResetIcon.vue';
import DownloadIcon from '@assets/icons/modules/analytics/bi/DownloadIcon.vue';
import DateRangeDisplayInput from '@/views/components/date-display-input/DateRangeDisplayInput.vue';
import SegmentType from './SegmentType.vue';

const tabNavActive: Ref<string> = ref('CUSTOMERLIST');
const itemDropdownSave = ref([{ title: 'การจัดกลุ่มเป้าหมายทีบันทึกเอง', icon: markRaw(BoxIcon) }]);
const itemDropdownShare = ref([
  { title: 'SMS', icon: markRaw(SmsIcon) },
  { title: 'Email', icon: markRaw(EmailIcon) },
  { title: 'Line', icon: markRaw(LineIcon) },
]);
const textSearch: Ref<string> = ref('');
const onBusy: Ref<boolean> = ref(false);
const startDate: Ref<Date | null> = ref(null);
const endDate: Ref<Date | null> = ref(null);
const isMainFilterChanged: Ref<boolean> = ref(false);
const loadingExportCsv: Ref<boolean> = ref(false);

const DEFAULT_DATE_FILTER = 'P90D';
const relativeModel: Ref<string | null> = ref(DEFAULT_DATE_FILTER);

function resolveSegmentType(type: Segment.SegmentType) {
  switch (type) {
    case 1:
      return 'Batch';
    case 2:
      return 'Realtime';
    case 3:
      return 'Custom';
  }
}

const onResetDate = async () => {
  // dynamicFilter.value = [];
  // dynamicChartFilter.value = [];
  // if (startDate.value == null && endDate.value == null) return;
  // if (relativeModel.value == 'P90D') {
  //   endDate.value = new Date();
  //   startDate.value = new Date(new Date().setDate(endDate.value.getDate() - 90));
  // } else {
  //   endDate.value = new Date();
  //   startDate.value = new Date(new Date().setDate(endDate.value.getDate() - 30));
  // }
  // onClickDateSelect();
  // await fetchBiGlobalFilter();
  // await nextTick(() => {
  //   isMainFilterChanged.value = false;
  //   setAllSeen(false);
  //   fetchLayoutBi(pageIdActive.value);
  // });
};

const onExportCSV = () => {
  loadingExportCsv.value = true;
  // exportFileCouponSet.payload.CouponId = router.currentRoute.value.query.couponId;
  // api
  //   .apiRequest(exportFileCouponSet)
  //   .then((response) => {
  //     const datesTime = new Date();
  //     saveAs(
  //       response,
  //       `CouponCode_Report_${
  //         detailCoupon.couponName
  //       }_${datesTime.getFullYear()}${datesTime.getMonth()}${datesTime.getDate()}_${datesTime.getHours()}${datesTime.getMinutes()}${datesTime.getSeconds()}.csv`,
  //     );
  //   })
  //   .catch((err) => {
  //     openErrorModal(err.data.error.locale['th-th'].title as string, err.data.error.locale['th-th'].message as string);
  //   })
  //   .finally(() => {
  //     loadingExportCsv.value = false;
  //   });
  setTimeout(() => {
    loadingExportCsv.value = false;
  }, 3000);
};
const onClickDateSelect = () => {
  isMainFilterChanged.value = true;
};
const onClickSaveOpensaveSegmentModal = () => {
  // saveSegmentModal.value.isOpen = true;
};
const onClickShare = () => {
  console.log('onClickShare');
};
function onClickTabNav(tab: string) {
  tabNavActive.value = tab;
}

function onClickCalButton() {
  router.push({
    path: '/analytics/churnRate/calculate',
    query: {
      ...router.currentRoute.value.query,
    },
  });
}
</script>

<style lang="scss" scoped>
.customer-segment {
  padding: 16px;

  .segment-header {
    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 24px;
    border-radius: 10px;
    background: #fff;
    width: 100%;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    .segment-info {
      display: flex;
      width: 75%;
      align-items: center;
      justify-content: space-around;

      .segment-info-item {
        display: flex;
        flex-direction: column;
        max-width: 200px;
        line-height: 40px;
        justify-content: center; /* จัดให้อยู่ตรงกลางแนวนอน */
        align-items: center; /* จัดให้อยู่ตรงกลางแนวตั้ง */
        height: 100%; /* กำหนดความสูงถ้าจำเป็น */
        .segment-info-item-header {
          width: 100%;
          color: #646464;
          /* Text Reg 16 */
          font-family: Prompt;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          max-width: 180px; /* กำหนดความกว้างสูงสุด */
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .segment-info-item-value {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          color: #646464;
          /* Text Bold 16 */
          font-family: Prompt;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          max-width: 180px; /* กำหนดความกว้างสูงสุด */
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;
          .campaign-status-symbol {
            border-radius: 50%;
            width: 0.5rem;
            height: 0.5rem;
            margin: auto 0.5rem auto auto;
            background-color: rgba(255, 255, 255, 0);
            &.available {
              background-color: #4cba37;
            }

            &.redeemed {
              background-color: #fccc00;
            }

            &.delivered {
              background-color: #027fff;
            }

            &.completed {
              background-color: #227b36;
            }

            &.schedule {
              background-color: #00c4ff;
            }

            &.publish {
              background-color: #0fc600;
            }

            &.cancel {
              background-color: #b4b4b4;
            }

            &.draft {
              background-color: #f4ce00;
            }
          }
          .campaign-status-progress {
            color: #027fff;
          }
        }
      }
    }

    .segment-actions {
      width: 25%;
      border-left: 1px solid var(--Gray-02, #b4b4b4);
      .cal-button-container {
        display: flex;
        justify-content: flex-end;
        position: relative;
        right: 0;
        z-index: 1;
        margin-left: 0.5rem;
        width: auto;
        .cal-button {
          font-size: 15px;
          padding: 0.625rem;
          line-height: 1;
          border-radius: 7px;
          background: #fff;
          .cal-icon {
            margin-right: 0.5rem;
            svg {
              width: 21px;
              height: 21px;
              fill: #0d6efd;
            }
          }
          &:hover {
            box-shadow: #0038b7 -4px 4px 10px -6px;
            background: #0d6efd;
            .cal-icon {
              svg {
                fill: #fff;
              }
            }
          }
        }
      }
    }
  }

  .segment-nav {
    display: flex;
    padding: 25px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 10px;
    background: #fff;
    margin-top: 20px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    .segment-nav-tab-container {
      .end-nav-button {
        margin-left: 0.5rem;
      }

      .nav-button {
        background-color: transparent;
        border: none;
        color: #606a6c;
        fill: #606a6c;
        cursor: pointer;

        &.active {
          color: #007bff;
          fill: #007bff;
        }
      }
    }
    .segment-nav-button-container {
      display: flex;
      align-items: center;
      .dropdown-save {
        margin-right: 0.5rem;
      }
      .bi-reset-date-picker {
        min-width: 25px;
        width: 25px;
        height: 25px;
        background-color: rgb(96, 106, 108, 0.15);
        border-radius: 50%;
        margin-right: 0.5rem;
        margin-left: 0.5rem;
        display: flex;
        cursor: pointer;
        transition: 0.2s all;

        &:hover {
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          background-color: rgb(96, 106, 108, 0.3);

          svg {
            transform: rotate(45deg);
          }
        }

        svg {
          width: 15px;
          height: 14px;
          margin: auto;
          transition: 0.2s transform;
        }
      }

      .date-range-picker {
        max-width: 20rem !important;

        .choco-date-range-picker {
          margin: 0 0.5rem;
          position: relative;

          .title {
            position: absolute;
            top: 0;
            transform: translateY(-1.5rem);
          }

          .input {
            background-color: white;
            max-width: 290px;
            min-width: 290px;
            width: 100%;
          }
        }
      }

      .bi-filter-btn {
        border-radius: 8px;
      }

      .chart-action {
        display: flex;

        .bi-action-wrp {
          .create-bi-button {
            border-radius: 0.5rem;

            .add-icon {
              background: transparent;
              margin-right: 0.5rem;

              svg {
                width: 20px;
                fill: #007fff;
              }
            }

            &:hover {
              .add-icon {
                svg {
                  fill: white;
                }
              }
            }
          }
        }
      }
    }
  }
  .body-content-container {
    display: flex;
    padding: 20px;
    border-radius: 10px;
    background: #fff;
    margin-top: 20px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  }
  .spinner-border-container {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #30a704;
    height: 100%;
    width: 100%;
  }
  .spinner-border {
    height: 60%;
  }
  .export-button-container {
    .btn {
      color: #ffffff;
      background-color: #ffffff;
      border-color: #efefef;
      border-radius: 0.5rem;
      width: 43px;
      height: 43px;
      margin-left: 0.5rem;
    }
    .btn:hover {
      color: #fff;
      background-color: #30a704;
      border-color: #30a704;
      svg {
        fill: #ffffff;
      }
    }
  }
  :deep(.dropdown-share) {
    .dropdown-menu {
      .dropdown-item {
        cursor: pointer;
        &.item-custom {
          svg {
            width: 100%;
            max-width: 25px;
          }
        }
      }
    }
  }
}
</style>
